module.exports = __webpack_public_path__ + "img/rank5.7fb5512d.png";